import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const getStatistics = async () => {
  let request = await axios({
    method: "GET",
    url: endpoints.dashboard.GET_STATISTICS,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const getCurrentInventory = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.dashboard.GET_CURRENT_INVENTORY,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const getCategoryStats = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.dashboard.GET_CATEGORY_STATS,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const getRevenue = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.dashboard.GET_REVENUE,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const getInventoryFlow = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.dashboard.GET_INVENTORY_FLOW,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};
